export enum ConsultantServicePreferenceStatus {
  Active = "Active",
  Nullified = "Nullified"
}
